import { type BaseEvent, createEventBus } from '@littlebird/event-bus';

import type { Editor } from '@tiptap/core';

const EDITOR_BUBBLE_WILL_CLOSE = 'EDITOR_BUBBLE_WILL_CLOSE';
const EDITOR_OPEN_SEARCH_BAR = 'EDITOR_OPEN_SEARCH_BAR';

export interface EditorEventsRegistry {
  [EDITOR_BUBBLE_WILL_CLOSE]: undefined;
  [EDITOR_OPEN_SEARCH_BAR]: { editor: Editor };
}

type EditorEventMap = {
  [K in keyof EditorEventsRegistry]: BaseEvent & {
    type: K;
    data: EditorEventsRegistry[K];
  };
};

export const editorEventBus = createEventBus<EditorEventMap>({
  name: 'editorEventBus',
});
